var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.351 103.816h7.786l22.191-22.191 1.09-9.421a99.743 99.743 0 00-162.266 48.664 12.069 12.069 0 017.786-.467l44.382-7.32s2.258-3.737 3.426-3.503a55.36 55.36 0 0175.76-5.762z",
    fill: "#f44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M245.94 120.868a99.976 99.976 0 00-30.132-48.587l-31.146 31.146a55.36 55.36 0 0120.323 43.914v5.529a27.72 27.72 0 110 55.438h-55.439l-5.528 5.606v33.248l5.528 5.528h55.439a72.101 72.101 0 0040.956-131.822z",
    fill: "#448aff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.03 252.379h55.438v-44.382H94.03a27.564 27.564 0 01-11.446-2.492l-7.786 2.414-22.347 22.19-1.947 7.787a71.712 71.712 0 0043.526 14.483z",
    fill: "#43a047"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.03 108.41a72.101 72.101 0 00-43.526 129.252l32.158-32.157a27.72 27.72 0 1136.673-36.673l32.158-32.158A72.023 72.023 0 0094.03 108.41z",
    fill: "#ffc107"
  })));
}
export default SvgGcp;